<!-- 酒店房型管理（独立页，布局同 coffee.vue）：类型=2 且 身份类型=4 -->
<template>
  <el-container class="home-container">
    <el-header>
      <div>
        <span>畅游景德镇管理系统</span>
      </div>
      <h6>{{ userName }}, 你好</h6>
      <el-button type="info" @click="logout">退出</el-button>
    </el-header>
    <el-container>
      <el-aside width="200px">
        <div class="toggle-button">|||</div>
        <el-menu
          :default-active="activeMenu"
          background-color="#333744"
          text-color="#fff"
          active-text-color="#409eff"
          :router="true"
        >
          <el-menu-item
            :index="resolvePath(menu.菜单路由)"
            @click="saveNavState(menu.菜单路由)"
            v-for="menu in menuList"
            :key="menu.ID"
          >
            <template slot="title">
              <i :class="menu.菜单图标"></i>
              <span>{{ menu.菜单名称 }}</span>
            </template>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
  <div class="hotel-room-type">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>房型管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="main-card">
      <el-row :gutter="16" type="flex" align="middle" class="toolbar">
        <el-col :span="6">
          <el-select
            v-model="queryInfo.entityStatus"
            placeholder="房型状态"
            clearable
            style="width: 100%"
            @change="handleFilterChange"
          >
            <el-option label="全部" :value="''" />
            <el-option label="上架" :value="1" />
            <el-option label="下架" :value="2" />
          </el-select>
        </el-col>
        <el-col :span="18" style="text-align: right">
          <el-button type="primary" icon="el-icon-plus" @click="openCreate">新建房型</el-button>
        </el-col>
      </el-row>

      <el-table v-loading="loading" :data="tableData" border stripe style="width: 100%">
        <el-table-column prop="商品名称" label="房型/商品名称" min-width="160" show-overflow-tooltip />
        <el-table-column prop="展示价" label="展示价" width="100" />
        <el-table-column label="上架状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row['上架中'] ? 'success' : 'info'" size="small">
              {{ scope.row['上架中'] ? '上架中' : '已下架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="EntityStatus" label="状态码" width="80" align="center" />
        <el-table-column label="操作" width="220" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button
              v-if="!scope.row['上架中']"
              type="text"
              size="small"
              @click="doShelf(scope.row, true)"
            >上架</el-button>
            <el-button
              v-else
              type="text"
              size="small"
              @click="doShelf(scope.row, false)"
            >下架</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.currentPage"
        :page-size="queryInfo.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>

    <!-- 新建 -->
    <el-dialog
      title="新建房型"
      :visible.sync="createVisible"
      width="720px"
      destroy-on-close
      @closed="resetCreateForm"
    >
      <el-form ref="createFormRef" :model="createForm" :rules="createRules" label-width="120px">
        <el-form-item label="房型名称" prop="name">
          <el-input v-model="createForm.name" maxlength="80" show-word-limit placeholder="必填，同步为商品名称" />
        </el-form-item>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="售价" prop="price">
              <el-input v-model="createForm.price" placeholder="默认 0" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原价" prop="org_price">
              <el-input v-model="createForm.org_price" placeholder="默认与售价相同" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="商品简述" prop="intr">
          <el-input v-model="createForm.intr" type="textarea" :rows="2" />
        </el-form-item>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="库存" prop="stock">
              <el-input-number v-model="createForm.stock" :min="0" :max="9999999" style="width: 100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="商品主图">
          <el-upload
            class="hotel-multi-upload"
            action="#"
            list-type="picture-card"
            :http-request="(opt) => uploadImage(opt, 'create', 'img')"
            :before-upload="beforeImageUpload"
            :on-remove="(f) => removeUploadImage(f, 'create', 'img')"
            :file-list="createImgFileList"
            :limit="9"
            accept="image/*"
            multiple
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="upload-tip">最多 9 张，单张不超过 5MB</div>
        </el-form-item>
        <el-form-item label="房型图片">
          <el-upload
            class="hotel-multi-upload"
            action="#"
            list-type="picture-card"
            :http-request="(opt) => uploadImage(opt, 'create', 'room_img')"
            :before-upload="beforeImageUpload"
            :on-remove="(f) => removeUploadImage(f, 'create', 'room_img')"
            :file-list="createRoomImgFileList"
            :limit="9"
            accept="image/*"
            multiple
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="upload-tip">最多 9 张，单张不超过 5MB</div>
        </el-form-item>
        <el-form-item label="房型介绍" prop="room_intr">
          <el-input v-model="createForm.room_intr" type="textarea" :rows="3" placeholder="不传则使用房型名称" />
        </el-form-item>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="面积" prop="room_area">
              <el-input-number v-model="createForm.room_area" :min="0" style="width: 100%" controls-position="right" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="楼层" prop="floor">
              <el-input v-model="createForm.floor" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="窗型" prop="window_flag">
              <el-select v-model="createForm.window_flag" placeholder="请选择" clearable style="width: 100%">
                <el-option :value="0" label="无窗" />
                <el-option :value="1" label="有窗" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="最大入住" prop="max_number">
              <el-input-number v-model="createForm.max_number" :min="1" style="width: 100%" controls-position="right" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="含早" prop="has_breakfast">
              <el-select v-model="createForm.has_breakfast" placeholder="可选" clearable style="width: 100%">
                <el-option label="否/0" :value="0" />
                <el-option label="是/1" :value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="免费取消" prop="free_cancel">
              <el-select v-model="createForm.free_cancel" placeholder="可选" clearable style="width: 100%">
                <el-option label="否/0" :value="0" />
                <el-option label="是/1" :value="1" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="床型" prop="bed_sizes">
          <el-input v-model="createForm.bed_sizes" />
        </el-form-item>
        <el-form-item label="取消说明" prop="cancel_note">
          <el-input v-model="createForm.cancel_note" type="textarea" :rows="2" />
        </el-form-item>

        <el-divider content-position="left">时段 SKU（可选）</el-divider>
        <div v-for="(sku, idx) in createForm.sku_list" :key="'sku-' + idx" class="sku-row">
          <el-row :gutter="8">
            <el-col :span="7"><el-input v-model="sku.start_time" placeholder="开始日期" size="small" /></el-col>
            <el-col :span="7"><el-input v-model="sku.end_time" placeholder="结束日期" size="small" /></el-col>
            <el-col :span="4"><el-input v-model="sku.price" placeholder="价" size="small" /></el-col>
            <el-col :span="4"><el-input v-model="sku.number" placeholder="库存" size="small" /></el-col>
            <el-col :span="2">
              <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="removeSkuRow(idx)" />
            </el-col>
          </el-row>
        </div>
        <el-button type="text" icon="el-icon-plus" @click="addSkuRow">添加时段</el-button>
      </el-form>
      <span slot="footer">
        <el-button @click="createVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitCreate">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑 -->
    <el-dialog
      title="编辑房型"
      :visible.sync="editVisible"
      width="720px"
      destroy-on-close
      @closed="resetEditForm"
    >
      <el-form ref="editFormRef" :model="editForm" label-width="120px">
        <el-form-item label="房型名称" prop="name">
          <el-input v-model="editForm.name" />
        </el-form-item>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="售价(商品)" prop="price">
              <el-input v-model="editForm.price" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原价" prop="org_price">
              <el-input v-model="editForm.org_price" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="房型价格" prop="room_price">
          <el-input v-model="editForm.room_price" placeholder="仅改房型表价格时使用" />
        </el-form-item>
        <el-form-item label="商品简述" prop="intr">
          <el-input v-model="editForm.intr" type="textarea" :rows="2" />
        </el-form-item>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="库存" prop="stock">
              <el-input-number v-model="editForm.stock" :min="0" :max="9999999" style="width: 100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="商品主图">
          <el-upload
            class="hotel-multi-upload"
            action="#"
            list-type="picture-card"
            :http-request="(opt) => uploadImage(opt, 'edit', 'img')"
            :before-upload="beforeImageUpload"
            :on-remove="(f) => removeUploadImage(f, 'edit', 'img')"
            :file-list="editImgFileList"
            :limit="9"
            accept="image/*"
            multiple
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="upload-tip">最多 9 张，单张不超过 5MB</div>
        </el-form-item>
        <el-form-item label="房型图片">
          <el-upload
            class="hotel-multi-upload"
            action="#"
            list-type="picture-card"
            :http-request="(opt) => uploadImage(opt, 'edit', 'room_img')"
            :before-upload="beforeImageUpload"
            :on-remove="(f) => removeUploadImage(f, 'edit', 'room_img')"
            :file-list="editRoomImgFileList"
            :limit="9"
            accept="image/*"
            multiple
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="upload-tip">最多 9 张，单张不超过 5MB</div>
        </el-form-item>
        <el-form-item label="房型介绍" prop="room_intr">
          <el-input v-model="editForm.room_intr" type="textarea" :rows="3" />
        </el-form-item>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="面积" prop="room_area">
              <el-input-number v-model="editForm.room_area" :min="0" style="width: 100%" controls-position="right" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="楼层" prop="floor">
              <el-input v-model="editForm.floor" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="窗型" prop="window_flag">
              <el-select v-model="editForm.window_flag" placeholder="请选择" clearable style="width: 100%">
                <el-option :value="0" label="无窗" />
                <el-option :value="1" label="有窗" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="最大入住" prop="max_number">
              <el-input-number v-model="editForm.max_number" :min="1" style="width: 100%" controls-position="right" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="含早" prop="has_breakfast">
              <el-select v-model="editForm.has_breakfast" clearable style="width: 100%">
                <el-option label="否/0" :value="0" />
                <el-option label="是/1" :value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="免费取消" prop="free_cancel">
              <el-select v-model="editForm.free_cancel" clearable style="width: 100%">
                <el-option label="否/0" :value="0" />
                <el-option label="是/1" :value="1" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="床型" prop="bed_sizes">
          <el-input v-model="editForm.bed_sizes" />
        </el-form-item>
        <el-form-item label="取消说明" prop="cancel_note">
          <el-input v-model="editForm.cancel_note" type="textarea" :rows="2" />
        </el-form-item>

        <el-divider content-position="left">时段 SKU（可选）</el-divider>
        <div v-for="(sku, idx) in editForm.sku_list" :key="'esku-' + idx" class="sku-row">
          <el-row :gutter="8">
            <el-col :span="6"><el-input v-model="sku.start_time" placeholder="开始日期" size="small" /></el-col>
            <el-col :span="6"><el-input v-model="sku.end_time" placeholder="结束日期" size="small" /></el-col>
            <el-col :span="4"><el-input v-model="sku.price" placeholder="售价" size="small" /></el-col>
            <el-col :span="4"><el-input v-model="sku.org_price" placeholder="原价" size="small" /></el-col>
            <el-col :span="3"><el-input v-model="sku.number" placeholder="库存" size="small" /></el-col>
            <el-col :span="1">
              <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="removeEditSkuRow(idx)" />
            </el-col>
          </el-row>
        </div>
        <el-button type="text" icon="el-icon-plus" @click="addEditSkuRow">添加时段</el-button>
      </el-form>
      <span slot="footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitEdit">保 存</el-button>
      </span>
    </el-dialog>
  </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { isHotelCooperator } from '@/utils/hotelMerchant'

const emptyCreateForm = () => ({
  name: '',
  price: '',
  org_price: '',
  intr: '',
  img: [],
  stock: 99999,
  room_img: [],
  room_intr: '',
  room_area: undefined,
  floor: '',
  window_flag: undefined,
  max_number: undefined,
  has_breakfast: undefined,
  bed_sizes: '',
  cancel_note: '',
  free_cancel: undefined,
  sku_list: [],
})

const emptySku = () => ({
  ID: '',
  start_time: '',
  end_time: '',
  price: '',
  org_price: '',
  is_sell: '1',
  number: '',
})

export default {
  name: 'HotelRoomType',
  props: {
    basePath: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      menuList: [
        {
          ID: 1,
          菜单名称: '房型管理',
          菜单图标: 'el-icon-s-home',
          菜单路由: '/hotelRoomType',
        },
        {
          ID: 2,
          菜单名称: '实时订单',
          菜单图标: 'el-icon-s-order',
          菜单路由: '/hotelRealtimeOrder',
        },
      ],
      userName: window.sessionStorage.getItem('userName') || '',
      loading: false,
      tableData: [],
      total: 0,
      queryInfo: {
        currentPage: 1,
        pageSize: 20,
        entityStatus: '',
      },
      createVisible: false,
      createForm: emptyCreateForm(),
      createRules: {
        name: [{ required: true, message: '请输入房型名称', trigger: 'blur' }],
      },
      editVisible: false,
      editForm: {
        roomId: '',
        name: '',
        price: '',
        org_price: '',
        intr: '',
        img: [],
        stock: undefined,
        room_intr: '',
        room_img: [],
        room_price: '',
        room_area: undefined,
        floor: '',
        window_flag: undefined,
        max_number: undefined,
        has_breakfast: undefined,
        bed_sizes: '',
        cancel_note: '',
        free_cancel: undefined,
        sku_list: [],
      },
      submitLoading: false,
    }
  },
  created() {
    if (!isHotelCooperator()) {
      this.$message.warning('当前账号非酒店商家，无法访问房型管理')
      this.$router.replace('/message/count')
      return
    }
    window.sessionStorage.setItem('activePath', this.$route.path || '/hotelRoomType')
    this.fetchList()
  },
  computed: {
    activeMenu() {
      return this.$route.path || '/hotelRoomType'
    },
    createImgFileList() {
      return (this.createForm.img || []).map((item, i) =>
        this.imageItemToFileListItem(item, 'main', i)
      )
    },
    createRoomImgFileList() {
      return (this.createForm.room_img || []).map((item, i) =>
        this.imageItemToFileListItem(item, 'room', i)
      )
    },
    editImgFileList() {
      return (this.editForm.img || []).map((item, i) =>
        this.imageItemToFileListItem(item, 'main', i)
      )
    },
    editRoomImgFileList() {
      return (this.editForm.room_img || []).map((item, i) =>
        this.imageItemToFileListItem(item, 'room', i)
      )
    },
  },
  methods: {
    logout() {
      window.localStorage.clear()
      this.$router.push('/').catch(() => {})
    },
    saveNavState(activePath) {
      window.sessionStorage.setItem('activePath', activePath)
    },
    resolvePath(routePath) {
      if (routePath) {
        return routePath
      }
      return this.basePath
    },
    jsonHeaders() {
      return { 'Content-Type': 'application/json' }
    },
    /**
     * 与后端一致：'[{"url":"...","uid":123,"status":"success"},...]' 或已解析的数组
     * 表内存为 { url, uid, status }[]
     */
    normalizeImageMetaList(val) {
      if (val == null || val === '') return []
      let raw = val
      if (typeof val === 'string') {
        const s = val.trim()
        if (!s) return []
        try {
          raw = JSON.parse(s)
        } catch (e) {
          return [
            { url: s, uid: Date.now(), status: 'success' },
          ]
        }
      }
      if (!Array.isArray(raw)) return []
      return raw
        .map((item, i) => {
          if (typeof item === 'string' && item) {
            return {
              url: item,
              uid: Date.now() + i,
              status: 'success',
            }
          }
          if (item && typeof item === 'object' && item.url) {
            return {
              url: item.url,
              uid: item.uid != null ? item.uid : Date.now() + i,
              status: item.status || 'success',
            }
          }
          return null
        })
        .filter(Boolean)
    },
    imageItemToFileListItem(item, prefix, i) {
      const url = typeof item === 'string' ? item : item.url
      const uid =
        typeof item === 'object' && item.uid != null
          ? item.uid
          : `${prefix}-${i}`
      const row = {
        name: `${prefix}-${uid}`,
        url,
      }
      if (typeof item === 'object' && item.uid != null) row.uid = item.uid
      return row
    },
    /** 提交接口：JSON 字符串，元素含 url / uid / status */
    serializeImageFieldForApi(arr) {
      const list = Array.isArray(arr) ? arr : []
      const out = list
        .map((item, i) => {
          if (typeof item === 'string' && item) {
            return {
              url: item,
              uid: Date.now() + i,
              status: 'success',
            }
          }
          if (item && typeof item === 'object' && item.url) {
            return {
              url: item.url,
              uid: item.uid != null ? item.uid : Date.now() + i,
              status: item.status || 'success',
            }
          }
          return null
        })
        .filter(Boolean)
      return JSON.stringify(out)
    },
    extractUploadUrl(res) {
      if (!res || res.code !== 200) return ''
      const d = res.data
      if (typeof d === 'string') return d
      if (d && typeof d === 'object') {
        return d.url || d.path || d.link || d.src || ''
      }
      return ''
    },
    beforeImageUpload(file) {
      const isImg = file.type && file.type.startsWith('image/')
      if (!isImg) {
        this.$message.warning('请上传图片文件')
        return false
      }
      const max = 5 * 1024 * 1024
      if (file.size > max) {
        this.$message.warning('单张图片不能超过 5MB')
        return false
      }
      return true
    },
    uploadImage(options, scope, field) {
      const fd = new FormData()
      fd.append('file', options.file)
      this.$axios
        .post('/file/upload', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((res) => {
          const url = this.extractUploadUrl(res)
          if (!url) {
            this.$message.warning((res && res.msg) || '上传失败')
            if (options.onError) options.onError(new Error('no url'))
            return
          }
          const form = scope === 'create' ? this.createForm : this.editForm
          if (!Array.isArray(form[field])) this.$set(form, field, [])
          form[field].push({
            url,
            uid: Date.now(),
            status: 'success',
          })
          if (options.onSuccess) options.onSuccess(res, options.file)
        })
        .catch((err) => {
          this.$message.warning('上传失败')
          if (options.onError) options.onError(err)
        })
    },
    removeUploadImage(file, scope, field) {
      const form = scope === 'create' ? this.createForm : this.editForm
      const list = form[field] || []
      form[field] = list.filter((item) => {
        if (file.uid != null && typeof item === 'object' && item.uid != null) {
          return item.uid !== file.uid
        }
        const u = typeof item === 'string' ? item : item.url
        return u !== file.url
      })
    },
    buildListParams() {
      const p = {
        currentPage: this.queryInfo.currentPage,
        pageSize: this.queryInfo.pageSize,
      }
      if (this.queryInfo.entityStatus !== '' && this.queryInfo.entityStatus != null) {
        p.entityStatus = this.queryInfo.entityStatus
      }
      return p
    },
    fetchList() {
      this.loading = true
      this.$axios({
        method: 'get',
        url: '/manager/hotelRoomType/list',
        params: this.buildListParams(),
      })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data || []
            this.total = typeof res.total === 'number' ? res.total : (res.data && res.data.length) || 0
          } else {
            this.$message.warning(res.msg || '加载失败')
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    handleFilterChange() {
      this.queryInfo.currentPage = 1
      this.fetchList()
    },
    handleCurrentChange(page) {
      this.queryInfo.currentPage = page
      this.fetchList()
    },
    openCreate() {
      this.createForm = emptyCreateForm()
      this.createVisible = true
    },
    resetCreateForm() {
      this.createForm = emptyCreateForm()
      if (this.$refs.createFormRef) this.$refs.createFormRef.resetFields()
    },
    addSkuRow() {
      this.createForm.sku_list.push(emptySku())
    },
    removeSkuRow(i) {
      this.createForm.sku_list.splice(i, 1)
    },
    addEditSkuRow() {
      this.editForm.sku_list.push(emptySku())
    },
    removeEditSkuRow(i) {
      this.editForm.sku_list.splice(i, 1)
    },
    /** ISO / Date → 表单用 yyyy-MM-dd */
    /** 窗型：仅 0 无窗 / 1 有窗（接口可能是字符串） */
    normalizeWindowFlag(val) {
      if (val === '' || val === undefined || val === null) return undefined
      const n = Number(val)
      if (n === 0 || n === 1) return n
      return undefined
    },
    formatSkuDateForInput(val) {
      if (val === '' || val == null) return ''
      if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}/.test(val.trim())) {
        return val.trim().slice(0, 10)
      }
      const d = new Date(val)
      if (Number.isNaN(d.getTime())) return String(val)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    /** 详情接口 sku：兼容中英文字段；详情示例见「起始可用日期」「价格」「库存数量」等 */
    mapSkuRowFromApi(r) {
      if (!r || typeof r !== 'object') return emptySku()
      const pick = (...keys) => {
        for (const k of keys) {
          const v = r[k]
          if (v !== undefined && v !== null) return v
        }
        return ''
      }
      const start = pick(
        '起始可用日期',
        'start_time',
        'startTime',
        'StartTime',
        '开始时间',
        'begin_time'
      )
      const end = pick(
        '结束可用日期',
        'end_time',
        'endTime',
        'EndTime',
        '结束时间',
        'finish_time'
      )
      const price = pick('价格', 'price', '售价', 'sell_price')
      const org_price = pick('原价', 'org_price', 'orgPrice', 'market_price')
      const number = pick('库存数量', 'number', 'stock', '库存', '数量', 'qty')
      let is_sell = pick('本时段是否销售', 'is_sell', 'isSell', '在售')
      if (is_sell === '') is_sell = '1'
      else is_sell = String(is_sell)
      return {
        ID: r.ID != null ? String(r.ID) : '',
        start_time: this.formatSkuDateForInput(start),
        end_time: this.formatSkuDateForInput(end),
        price: price === '' ? '' : String(price),
        org_price: org_price === '' ? '' : String(org_price),
        is_sell,
        number: number === '' ? '' : String(number),
      }
    },
    normalizeSkuListForForm(raw) {
      if (!raw) return []
      const arr = Array.isArray(raw) ? raw : []
      return arr.map((item) => this.mapSkuRowFromApi(item))
    },
    normalizeCreatePayload() {
      const f = { ...this.createForm }
      const payload = {
        name: f.name,
        price: f.price === '' ? undefined : f.price,
        org_price: f.org_price === '' ? undefined : f.org_price,
        intr: f.intr || undefined,
        stock: f.stock,
        room_intr: f.room_intr || undefined,
        room_area: f.room_area,
        floor: f.floor || undefined,
        window_flag: f.window_flag,
        max_number: f.max_number,
        has_breakfast: f.has_breakfast,
        bed_sizes: f.bed_sizes || undefined,
        cancel_note: f.cancel_note || undefined,
        free_cancel: f.free_cancel,
      }
      if (Array.isArray(f.img) && f.img.length) {
        payload.img = this.serializeImageFieldForApi(f.img)
      }
      if (Array.isArray(f.room_img) && f.room_img.length) {
        payload.room_img = this.serializeImageFieldForApi(f.room_img)
      }
      const skus = (f.sku_list || []).filter(
        (s) => s.start_time && s.end_time && s.price !== '' && s.number !== ''
      )
      if (skus.length) {
        payload.sku_list = skus.map((s) => {
          const row = {
            start_time: s.start_time,
            end_time: s.end_time,
            price: s.price,
            org_price: s.org_price === '' ? s.price : s.org_price,
            is_sell: s.is_sell || '1',
            number: Number(s.number) || 0,
          }
          if (s.ID) row.ID = s.ID
          return row
        })
      }
      return payload
    },
    submitCreate() {
      this.$refs.createFormRef.validate((valid) => {
        if (!valid) return
        this.submitLoading = true
        this.$axios({
          method: 'post',
          url: '/manager/hotelRoomType/create',
          data: this.normalizeCreatePayload(),
          headers: this.jsonHeaders(),
        })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success('创建成功')
              this.createVisible = false
              this.fetchList()
            } else {
              this.$message.warning(res.msg || '创建失败')
            }
          })
          .catch(() => {})
          .finally(() => {
            this.submitLoading = false
          })
      })
    },
    openEdit(row) {
      const roomId = row.ID
      const loading = this.$loading({
        lock: true,
        text: '加载详情',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$axios({
        method: 'get',
        url: '/manager/hotelRoomType/detail',
        params: { roomId },
      })
        .then((res) => {
          if (res.code !== 200) {
            this.$message.warning(res.msg || '加载详情失败')
            return
          }
          const d = res.data || {}
          this.editForm = {
            roomId: d.ID || roomId,
            name: d['商品名称'] || '',
            price: d['商品价格'] != null ? String(d['商品价格']) : '',
            org_price: d['商品原价'] != null ? String(d['商品原价']) : '',
            intr: d['商品简述'] || '',
            img: this.normalizeImageMetaList(d['商品图片']),
            stock: d['stock'] != null ? d['stock'] : d['库存'],
            room_intr: d['介绍'] || d.room_intr || '',
            room_img: this.normalizeImageMetaList(d['房型图片']),
            room_price: d['房型价格'] != null ? String(d['房型价格']) : '',
            room_area: d.area != null ? d.area : d['room_area'],
            floor: d.floor != null ? String(d.floor) : '',
            window_flag: this.normalizeWindowFlag(
              d.window_flag !== undefined && d.window_flag !== null
                ? d.window_flag
                : d.window
            ),
            max_number: d.max_number,
            has_breakfast: d.has_breakfast,
            bed_sizes: d.bed_sizes || '',
            cancel_note: d.cancel_note || '',
            free_cancel: d.free_cancel,
            sku_list: this.normalizeSkuListForForm(
              d.sku || d.sku_list || d.SkuList
            ),
          }
          this.editVisible = true
        })
        .catch(() => {})
        .finally(() => {
          loading.close()
        })
    },
    resetEditForm() {
      this.editForm = {
        roomId: '',
        name: '',
        price: '',
        org_price: '',
        intr: '',
        img: [],
        stock: undefined,
        room_intr: '',
        room_img: [],
        room_price: '',
        room_area: undefined,
        floor: '',
        window_flag: undefined,
        max_number: undefined,
        has_breakfast: undefined,
        bed_sizes: '',
        cancel_note: '',
        free_cancel: undefined,
        sku_list: [],
      }
    },
    buildUpdatePayload() {
      const e = this.editForm
      const payload = { roomId: e.roomId }
      const set = (k, v) => {
        if (v !== '' && v !== undefined && v !== null) payload[k] = v
      }
      set('name', e.name)
      set('price', e.price)
      set('org_price', e.org_price)
      set('intr', e.intr)
      payload.img = this.serializeImageFieldForApi(e.img)
      if (e.stock !== undefined && e.stock !== null) payload.stock = e.stock
      set('room_intr', e.room_intr)
      payload.room_img = this.serializeImageFieldForApi(e.room_img)
      set('room_price', e.room_price)
      set('room_area', e.room_area)
      set('floor', e.floor)
      if (e.window_flag !== undefined && e.window_flag !== null) {
        payload.window_flag = e.window_flag
      }
      set('max_number', e.max_number)
      set('has_breakfast', e.has_breakfast)
      set('bed_sizes', e.bed_sizes)
      set('cancel_note', e.cancel_note)
      set('free_cancel', e.free_cancel)
      const eskus = (e.sku_list || []).filter(
        (s) => s.start_time && s.end_time && s.price !== '' && s.number !== ''
      )
      if (eskus.length) {
        payload.sku_list = eskus.map((s) => {
          const row = {
            start_time: s.start_time,
            end_time: s.end_time,
            price: s.price,
            org_price: s.org_price === '' ? s.price : s.org_price,
            is_sell: s.is_sell || '1',
            number: Number(s.number) || 0,
          }
          if (s.ID) row.ID = s.ID
          return row
        })
      }
      return payload
    },
    submitEdit() {
      this.submitLoading = true
      this.$axios({
        method: 'post',
        url: '/manager/hotelRoomType/update',
        data: this.buildUpdatePayload(),
        headers: this.jsonHeaders(),
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.editVisible = false
            this.fetchList()
          } else {
            this.$message.warning(res.msg || '保存失败')
          }
        })
        .catch(() => {})
        .finally(() => {
          this.submitLoading = false
        })
    },
    doShelf(row, onShelf) {
      const tip = onShelf ? '确认上架该房型？' : '确认下架该房型？'
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: '提交中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })
          this.$axios({
            method: 'post',
            url: '/manager/hotelRoomType/shelf',
            data: { roomId: row.ID, onShelf },
            headers: this.jsonHeaders(),
          })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success(onShelf ? '已上架' : '已下架')
                this.fetchList()
              } else {
                this.$message.warning(res.msg || '操作失败')
              }
            })
            .catch(() => {})
            .finally(() => {
              loading.close()
            })
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped>
.hotel-room-type {
  padding: 8px;
}
.main-card {
  margin-top: 12px;
}
.toolbar {
  margin-bottom: 16px;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
.sku-row {
  margin-bottom: 8px;
}
.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
}
.hotel-multi-upload >>> .el-upload--picture-card {
  background-color: #fbfdff;
}
</style>

<style>
.home-container {
  height: 100vh;
}
.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
}
.el-aside {
  background-color: #333744;
}
.el-main {
  background-color: #eaedf1;
}
.el-aside .toggle-button {
  background-color: #4a5064;
  color: #fff;
  height: 30px;
  line-height: 30px;
  text-align: center;
}
</style>
